import React from 'react';
import { CheckCircle2, AlertTriangle, PackageCheck, PackageX, Clock } from 'lucide-react';

// The health of the eBay order pull, read straight off the settings record the
// pull writes. A failed run is shown as a failure with its reason — never as a
// blank success — so a dropped sale cannot pass unnoticed again.
export default function EbaySyncHealth({ settings }) {
  const status = settings?.last_order_sync_status;
  const failed = status === 'error';
  const message = settings?.last_order_sync_message || (failed ? settings?.last_error : '') || '';
  const ranAt = settings?.last_order_sync
    ? new Date(settings.last_order_sync).toLocaleString('en-GB', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : 'Never';

  return (
    <div
      className={`border p-6 ${
        failed ? 'border-red-500/40 bg-red-500/5' : 'border-white/10 bg-[#111115]'
      }`}
    >
      <div className="flex items-center gap-2">
        {failed ? (
          <AlertTriangle className="w-4 h-4 text-red-400" />
        ) : (
          <CheckCircle2 className="w-4 h-4 text-emerald-400" />
        )}
        <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
          Order Pull Health
        </h3>
        <span
          className={`ml-auto text-[11px] font-bold tracking-widest px-2 py-0.5 border ${
            failed
              ? 'text-red-400 border-red-400/40'
              : status === 'ok'
                ? 'text-emerald-400 border-emerald-400/40'
                : 'text-white/40 border-white/15'
          }`}
        >
          {failed ? 'LAST RUN FAILED' : status === 'ok' ? 'LAST RUN OK' : 'NOT RUN YET'}
        </span>
      </div>

      <p className="text-xs text-white/50 mt-2 flex items-center gap-1.5">
        <Clock className="w-3.5 h-3.5" /> Last completed pull: {ranAt}
      </p>

      {status === 'ok' && (
        <div className="grid grid-cols-3 gap-3 mt-4">
          <div className="border border-white/10 p-3">
            <div className="text-[11px] text-white/40 uppercase tracking-wider">Found</div>
            <div className="text-white text-sm font-medium">
              {settings?.last_order_sync_found ?? 0}
            </div>
          </div>
          <div className="border border-white/10 p-3">
            <div className="text-[11px] text-white/40 uppercase tracking-wider flex items-center gap-1">
              <PackageCheck className="w-3 h-3" /> Imported
            </div>
            <div className="text-white text-sm font-medium">
              {settings?.last_order_sync_imported ?? 0}
            </div>
          </div>
          <div className="border border-white/10 p-3">
            <div className="text-[11px] text-white/40 uppercase tracking-wider flex items-center gap-1">
              <PackageX className="w-3 h-3" /> Already held
            </div>
            <div className="text-white text-sm font-medium">
              {settings?.last_order_sync_skipped ?? 0}
            </div>
          </div>
        </div>
      )}

      {message && (
        <p className={`text-xs mt-3 ${failed ? 'text-red-400' : 'text-amber-400'}`}>{message}</p>
      )}

      {!status && (
        <p className="text-xs text-white/40 mt-3">
          The pull runs automatically every morning at 6am. Use the buttons below to run it now.
        </p>
      )}
    </div>
  );
}